import { useSyncExternalStore } from 'react';

/**
 * Режим превью (23.10.2026): кабинет партнёра показывает настоящую главную мини-аппа
 * в рамке телефона (`/preview.html`, вход `src/preview/boot.ts`). Данные выдуманные,
 * запросы к API не уходят, Telegram не нужен. Тему, схему, цвет, название и сезон
 * кабинет присылает `postMessage`, страница применяет их без перезагрузки.
 */
export const IS_PREVIEW = typeof location !== 'undefined' && /\/preview\.html$/.test(location.pathname);

let revision = 0;
const listeners = new Set<() => void>();

/** Название или логотип бота сменились: каркас перемонтирует экран, чтобы карта их перечитала. */
export function bumpPreviewRevision(): void {
  revision += 1;
  listeners.forEach((cb) => cb());
}

const subscribe = (cb: () => void) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

export const usePreviewRevision = () => useSyncExternalStore(subscribe, () => revision, () => 0);
